export const USERS_RETRIEVE = "users.retrieve";
export const USERS_CREATE = "users.create";
export const USERS_UPDATE = "users.update";
export const USERS_DESTROY = "users.destroy";

export const SUPPLIERS_RETRIEVE = "suppliers.retrieve";
export const SUPPLIERS_CREATE = "suppliers.create";
export const SUPPLIERS_UPDATE = "suppliers.update";
export const SUPPLIERS_DESTROY = "suppliers.destroy";

export const INVOICES_RETRIEVE = "invoices.retrieve";
export const INVOICES_CREATE = "invoices.create";
export const INVOICES_UPDATE = "invoices.update";
export const INVOICES_DESTROY = "invoices.destroy";

export const CREDIT_NOTES_RETRIEVE = "credit_notes.retrieve";
export const CREDIT_NOTES_CREATE = "credit_notes.create";
export const CREDIT_NOTES_UPDATE = "credit_notes.update";
export const CREDIT_NOTES_DESTROY = "credit_notes.destroy";

export const DEBIT_NOTES_RETRIEVE = "debit_notes.retrieve";
export const DEBIT_NOTES_CREATE = "debit_notes.create";
export const DEBIT_NOTES_UPDATE = "debit_notes.update";
export const DEBIT_NOTES_DESTROY = "debit_notes.destroy";

export const REMISSION_NOTES_RETRIEVE = "remission_notes.retrieve";
export const REMISSION_NOTES_CREATE = "remission_notes.create";
export const REMISSION_NOTES_UPDATE = "remission_notes.update";
export const REMISSION_NOTES_DESTROY = "remission_notes.destroy";

export const AUTO_INVOICES_RETRIEVE = "auto_invoices.retrieve";
export const AUTO_INVOICES_CREATE = "auto_invoices.create";
export const AUTO_INVOICES_UPDATE = "auto_invoices.update";
export const AUTO_INVOICES_DESTROY = "auto_invoices.destroy";

export const RECEIPTS_RETRIEVE = "receipts.retrieve";
export const RECEIPTS_CREATE = "receipts.create";
export const RECEIPTS_UPDATE = "receipts.update";
export const RECEIPTS_DESTROY = "receipts.destroy";

export const DISABLEMENTS_RETRIEVE = "disablements.retrieve";
export const DISABLEMENTS_CREATE = "disablements.create";
export const DISABLEMENTS_UPDATE = "disablements.update";
export const DISABLEMENTS_DESTROY = "disablements.destroy";

export const RECEIVED_INVOICES_RETRIEVE = "received_invoices.retrieve";
export const RECEIVED_INVOICES_CREATE = "received_invoices.create";
export const RECEIVED_INVOICES_UPDATE = "received_invoices.update";
export const RECEIVED_INVOICES_DESTROY = "received_invoices.destroy";

export const RECEIVED_DOCUMENTS_RETRIEVE = "received_documents.retrieve";
export const RECEIVED_DOCUMENTS_CREATE = "received_documents.create";
export const RECEIVED_DOCUMENTS_UPDATE = "received_documents.update";
export const RECEIVED_DOCUMENTS_DESTROY = "received_documents.destroy";

export const RECEIVED_DOCUMENTS_RETRIEVE_LABEL = "Ver";
export const RECEIVED_DOCUMENTS_CREATE_LABEL = "Crear";
export const RECEIVED_DOCUMENTS_UPDATE_LABEL = "Actualizar";
export const RECEIVED_DOCUMENTS_DESTROY_LABEL = "Eliminar";

export const RECEIVED_DOCUMENTS_GROUP_LABEL = "Documentos Recibidos";

export const ACCOUNTING_ENTRIES_RETRIEVE = "accounting_entries.retrieve";
export const ACCOUNTING_ENTRIES_CREATE = "accounting_entries.create";
export const ACCOUNTING_ENTRIES_UPDATE = "accounting_entries.update";
export const ACCOUNTING_ENTRIES_DESTROY = "accounting_entries.destroy";

export const IVA_RETRIEVE = "iva.retrieve";
export const IVA_INCLUSIONS_UPDATE = "iva.inclusions.update";

export const IVA_RETRIEVE_LABEL = "Ver";
export const IVA_INCLUSIONS_UPDATE_LABEL = "Actualizar inclusiones";

export const IVA_GROUP_LABEL = "IVA";

export const TAX_PAYER_SETTINGS_RETRIEVE = "tax_payer_settings.retrieve";
export const TAX_PAYER_SETTINGS_UPDATE = "tax_payer_settings.update";

export const CONNECTIVITY_MANAGE = "connectivity.manage";

// Whether this person may connect an AI to this company, and whether that AI may
// prepare drafts. Two switches, not a scope: the AI inherits what the person can
// already do, it never gets a permission surface of its own.
export const AI_ACCESS = "ai.access";
export const AI_WRITE = "ai.write";

// Permission labels
export const USERS_RETRIEVE_LABEL = "Ver";
export const USERS_CREATE_LABEL = "Crear";
export const USERS_UPDATE_LABEL = "Actualizar";
export const USERS_DESTROY_LABEL = "Eliminar";

export const SUPPLIERS_RETRIEVE_LABEL = "Ver";
export const SUPPLIERS_CREATE_LABEL = "Crear";
export const SUPPLIERS_UPDATE_LABEL = "Actualizar";
export const SUPPLIERS_DESTROY_LABEL = "Eliminar";

export const INVOICES_RETRIEVE_LABEL = "Ver";
export const INVOICES_CREATE_LABEL = "Crear";
export const INVOICES_UPDATE_LABEL = "Actualizar";
export const INVOICES_DESTROY_LABEL = "Eliminar";

export const CREDIT_NOTES_RETRIEVE_LABEL = "Ver";
export const CREDIT_NOTES_CREATE_LABEL = "Crear";
export const CREDIT_NOTES_UPDATE_LABEL = "Actualizar";
export const CREDIT_NOTES_DESTROY_LABEL = "Eliminar";

export const DEBIT_NOTES_RETRIEVE_LABEL = "Ver";
export const DEBIT_NOTES_CREATE_LABEL = "Crear";
export const DEBIT_NOTES_UPDATE_LABEL = "Actualizar";
export const DEBIT_NOTES_DESTROY_LABEL = "Eliminar";

export const REMISSION_NOTES_RETRIEVE_LABEL = "Ver";
export const REMISSION_NOTES_CREATE_LABEL = "Crear";
export const REMISSION_NOTES_UPDATE_LABEL = "Actualizar";
export const REMISSION_NOTES_DESTROY_LABEL = "Eliminar";

export const AUTO_INVOICES_RETRIEVE_LABEL = "Ver";
export const AUTO_INVOICES_CREATE_LABEL = "Crear";
export const AUTO_INVOICES_UPDATE_LABEL = "Actualizar";
export const AUTO_INVOICES_DESTROY_LABEL = "Eliminar";

export const RECEIPTS_RETRIEVE_LABEL = "Ver";
export const RECEIPTS_CREATE_LABEL = "Crear";
export const RECEIPTS_UPDATE_LABEL = "Actualizar";
export const RECEIPTS_DESTROY_LABEL = "Eliminar";

export const DISABLEMENTS_RETRIEVE_LABEL = "Ver";
export const DISABLEMENTS_CREATE_LABEL = "Crear";
export const DISABLEMENTS_UPDATE_LABEL = "Actualizar";
export const DISABLEMENTS_DESTROY_LABEL = "Eliminar";

export const RECEIVED_INVOICES_RETRIEVE_LABEL = "Ver";
export const RECEIVED_INVOICES_CREATE_LABEL = "Crear";
export const RECEIVED_INVOICES_UPDATE_LABEL = "Actualizar";
export const RECEIVED_INVOICES_DESTROY_LABEL = "Eliminar";

export const ACCOUNTING_ENTRIES_RETRIEVE_LABEL = "Ver";
export const ACCOUNTING_ENTRIES_CREATE_LABEL = "Crear";
export const ACCOUNTING_ENTRIES_UPDATE_LABEL = "Actualizar";
export const ACCOUNTING_ENTRIES_DESTROY_LABEL = "Eliminar";

export const TAX_PAYER_SETTINGS_RETRIEVE_LABEL = "Ver";
export const TAX_PAYER_SETTINGS_UPDATE_LABEL = "Actualizar";

export const CONNECTIVITY_MANAGE_LABEL = "Gestionar";

export const AI_ACCESS_LABEL = "Conectar una IA";
export const AI_WRITE_LABEL = "Preparar borradores";

// Permission group labels
export const USERS_GROUP_LABEL = "Usuarios";
export const SUPPLIERS_GROUP_LABEL = "Proveedores";
export const INVOICES_GROUP_LABEL = "Facturas";
export const CREDIT_NOTES_GROUP_LABEL = "Notas de Crédito";
export const DEBIT_NOTES_GROUP_LABEL = "Notas de Débito";
export const REMISSION_NOTES_GROUP_LABEL = "Notas de Remisión";
export const AUTO_INVOICES_GROUP_LABEL = "Autofacturas";
export const RECEIPTS_GROUP_LABEL = "Recibos";
export const DISABLEMENTS_GROUP_LABEL = "Anulaciones";
export const RECEIVED_INVOICES_GROUP_LABEL = "Facturas Recibidas";
export const ACCOUNTING_ENTRIES_GROUP_LABEL = "Contabilidad";
export const TAX_PAYER_SETTINGS_GROUP_LABEL = "Configuraciones";
export const CONNECTIVITY_GROUP_LABEL = "Conectividad";
export const AI_GROUP_LABEL = "Inteligencia Artificial";

export const ALL_PERMISSIONS: string[] = [
  // Users
  USERS_RETRIEVE,
  USERS_CREATE,
  USERS_UPDATE,
  USERS_DESTROY,
  // Suppliers
  SUPPLIERS_RETRIEVE,
  SUPPLIERS_CREATE,
  SUPPLIERS_UPDATE,
  SUPPLIERS_DESTROY,

  // Invoices
  INVOICES_RETRIEVE,
  INVOICES_CREATE,
  INVOICES_UPDATE,
  INVOICES_DESTROY,

  // Credit Notes
  CREDIT_NOTES_RETRIEVE,
  CREDIT_NOTES_CREATE,
  CREDIT_NOTES_UPDATE,
  CREDIT_NOTES_DESTROY,

  // Debit Notes
  DEBIT_NOTES_RETRIEVE,
  DEBIT_NOTES_CREATE,
  DEBIT_NOTES_UPDATE,
  DEBIT_NOTES_DESTROY,

  // Remission Notes
  REMISSION_NOTES_RETRIEVE,
  REMISSION_NOTES_CREATE,
  REMISSION_NOTES_UPDATE,
  REMISSION_NOTES_DESTROY,

  // Auto Invoices
  AUTO_INVOICES_RETRIEVE,
  AUTO_INVOICES_CREATE,
  AUTO_INVOICES_UPDATE,
  AUTO_INVOICES_DESTROY,

  // Receipts
  RECEIPTS_RETRIEVE,
  RECEIPTS_CREATE,
  RECEIPTS_UPDATE,
  RECEIPTS_DESTROY,

  // Disablements
  DISABLEMENTS_RETRIEVE,
  DISABLEMENTS_CREATE,
  DISABLEMENTS_UPDATE,
  DISABLEMENTS_DESTROY,

  // Received Documents
  RECEIVED_DOCUMENTS_RETRIEVE,
  RECEIVED_DOCUMENTS_CREATE,
  RECEIVED_DOCUMENTS_UPDATE,
  RECEIVED_DOCUMENTS_DESTROY,

  //Accounting Entries
  ACCOUNTING_ENTRIES_RETRIEVE,
  ACCOUNTING_ENTRIES_CREATE,
  ACCOUNTING_ENTRIES_UPDATE,
  ACCOUNTING_ENTRIES_DESTROY,

  // IVA
  IVA_RETRIEVE,
  IVA_INCLUSIONS_UPDATE,

  // Tax Payer settings
  TAX_PAYER_SETTINGS_RETRIEVE,
  TAX_PAYER_SETTINGS_UPDATE,

  // Connectivity
  CONNECTIVITY_MANAGE,

  // AI
  AI_ACCESS,
  AI_WRITE,
];

// Permission groups
export const PERMISSION_GROUPS: Map<
  string,
  { value: string; label: string }[]
> = new Map([
  [
    USERS_GROUP_LABEL,
    [
      { value: USERS_RETRIEVE, label: USERS_RETRIEVE_LABEL },
      { value: USERS_CREATE, label: USERS_CREATE_LABEL },
      { value: USERS_UPDATE, label: USERS_UPDATE_LABEL },
      { value: USERS_DESTROY, label: USERS_DESTROY_LABEL },
    ],
  ],

  [
    SUPPLIERS_GROUP_LABEL,
    [
      { value: SUPPLIERS_RETRIEVE, label: SUPPLIERS_RETRIEVE_LABEL },
      { value: SUPPLIERS_CREATE, label: SUPPLIERS_CREATE_LABEL },
      { value: SUPPLIERS_UPDATE, label: SUPPLIERS_UPDATE_LABEL },
      { value: SUPPLIERS_DESTROY, label: SUPPLIERS_DESTROY_LABEL },
    ],
  ],

  [
    INVOICES_GROUP_LABEL,
    [
      { value: INVOICES_RETRIEVE, label: INVOICES_RETRIEVE_LABEL },
      { value: INVOICES_CREATE, label: INVOICES_CREATE_LABEL },
      { value: INVOICES_UPDATE, label: INVOICES_UPDATE_LABEL },
      { value: INVOICES_DESTROY, label: INVOICES_DESTROY_LABEL },
    ],
  ],
  [
    CREDIT_NOTES_GROUP_LABEL,
    [
      { value: CREDIT_NOTES_RETRIEVE, label: CREDIT_NOTES_RETRIEVE_LABEL },
      { value: CREDIT_NOTES_CREATE, label: CREDIT_NOTES_CREATE_LABEL },
      { value: CREDIT_NOTES_UPDATE, label: CREDIT_NOTES_UPDATE_LABEL },
      { value: CREDIT_NOTES_DESTROY, label: CREDIT_NOTES_DESTROY_LABEL },
    ],
  ],
  [
    DEBIT_NOTES_GROUP_LABEL,
    [
      { value: DEBIT_NOTES_RETRIEVE, label: DEBIT_NOTES_RETRIEVE_LABEL },
      { value: DEBIT_NOTES_CREATE, label: DEBIT_NOTES_CREATE_LABEL },
      { value: DEBIT_NOTES_UPDATE, label: DEBIT_NOTES_UPDATE_LABEL },
      { value: DEBIT_NOTES_DESTROY, label: DEBIT_NOTES_DESTROY_LABEL },
    ],
  ],
  [
    REMISSION_NOTES_GROUP_LABEL,
    [
      {
        value: REMISSION_NOTES_RETRIEVE,
        label: REMISSION_NOTES_RETRIEVE_LABEL,
      },
      { value: REMISSION_NOTES_CREATE, label: REMISSION_NOTES_CREATE_LABEL },
      { value: REMISSION_NOTES_UPDATE, label: REMISSION_NOTES_UPDATE_LABEL },
      { value: REMISSION_NOTES_DESTROY, label: REMISSION_NOTES_DESTROY_LABEL },
    ],
  ],
  [
    AUTO_INVOICES_GROUP_LABEL,
    [
      { value: AUTO_INVOICES_RETRIEVE, label: AUTO_INVOICES_RETRIEVE_LABEL },
      { value: AUTO_INVOICES_CREATE, label: AUTO_INVOICES_CREATE_LABEL },
      { value: AUTO_INVOICES_UPDATE, label: AUTO_INVOICES_UPDATE_LABEL },
      { value: AUTO_INVOICES_DESTROY, label: AUTO_INVOICES_DESTROY_LABEL },
    ],
  ],
  [
    RECEIPTS_GROUP_LABEL,
    [
      { value: RECEIPTS_RETRIEVE, label: RECEIPTS_RETRIEVE_LABEL },
      { value: RECEIPTS_CREATE, label: RECEIPTS_CREATE_LABEL },
      { value: RECEIPTS_UPDATE, label: RECEIPTS_UPDATE_LABEL },
      { value: RECEIPTS_DESTROY, label: RECEIPTS_DESTROY_LABEL },
    ],
  ],
  [
    DISABLEMENTS_GROUP_LABEL,
    [
      { value: DISABLEMENTS_RETRIEVE, label: DISABLEMENTS_RETRIEVE_LABEL },
      { value: DISABLEMENTS_CREATE, label: DISABLEMENTS_CREATE_LABEL },
      { value: DISABLEMENTS_UPDATE, label: DISABLEMENTS_UPDATE_LABEL },
      { value: DISABLEMENTS_DESTROY, label: DISABLEMENTS_DESTROY_LABEL },
    ],
  ],
  [
    RECEIVED_DOCUMENTS_GROUP_LABEL,
    [
      {
        value: RECEIVED_DOCUMENTS_RETRIEVE,
        label: RECEIVED_DOCUMENTS_RETRIEVE_LABEL,
      },
      {
        value: RECEIVED_DOCUMENTS_CREATE,
        label: RECEIVED_DOCUMENTS_CREATE_LABEL,
      },
      {
        value: RECEIVED_DOCUMENTS_UPDATE,
        label: RECEIVED_DOCUMENTS_UPDATE_LABEL,
      },
      {
        value: RECEIVED_DOCUMENTS_DESTROY,
        label: RECEIVED_DOCUMENTS_DESTROY_LABEL,
      },
    ],
  ],
  [
    ACCOUNTING_ENTRIES_GROUP_LABEL,
    [
      {
        value: ACCOUNTING_ENTRIES_RETRIEVE,
        label: ACCOUNTING_ENTRIES_RETRIEVE_LABEL,
      },
      {
        value: ACCOUNTING_ENTRIES_CREATE,
        label: ACCOUNTING_ENTRIES_CREATE_LABEL,
      },
      {
        value: ACCOUNTING_ENTRIES_UPDATE,
        label: ACCOUNTING_ENTRIES_UPDATE_LABEL,
      },
      {
        value: ACCOUNTING_ENTRIES_DESTROY,
        label: ACCOUNTING_ENTRIES_DESTROY_LABEL,
      },
    ],
  ],
  [
    IVA_GROUP_LABEL,
    [
      { value: IVA_RETRIEVE, label: IVA_RETRIEVE_LABEL },
      { value: IVA_INCLUSIONS_UPDATE, label: IVA_INCLUSIONS_UPDATE_LABEL },
    ],
  ],
  [
    TAX_PAYER_SETTINGS_GROUP_LABEL,
    [
      {
        value: TAX_PAYER_SETTINGS_RETRIEVE,
        label: TAX_PAYER_SETTINGS_RETRIEVE_LABEL,
      },
      {
        value: TAX_PAYER_SETTINGS_UPDATE,
        label: TAX_PAYER_SETTINGS_UPDATE_LABEL,
      },
    ],
  ],
  [
    CONNECTIVITY_GROUP_LABEL,
    [
      {
        value: CONNECTIVITY_MANAGE,
        label: CONNECTIVITY_MANAGE_LABEL,
      },
    ],
  ],
  [
    AI_GROUP_LABEL,
    [
      { value: AI_ACCESS, label: AI_ACCESS_LABEL },
      { value: AI_WRITE, label: AI_WRITE_LABEL },
    ],
  ],
]);
